export default __webpack_public_path__ + "static/media/Trevor Smith Resume.4ab9efb2.pdf";